import Resource from '@/api/resource'
import request from '@/utils/request'
import store from '@/store/index'

class Institutions extends Resource {
  constructor() {
    super('institutions')
  }

  list(query) {
    return request({
      url: `${this.uri}/index`,
      method: 'POST',
      data: query,
    })
  }

  remove(id) {
    return request({
      url: `/${this.uri}/${id}`,
      method: 'delete',
      headers: { 'Content-Type': 'application/json' },
    })
  }

  store(query) {
    return request({
      url: `/${this.uri}/store`,
      method: 'post',
      data: query,
    })
  }

  put(query) {
    return request({
      url: `/${this.uri}/store`,
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      data: query,
    })
  }

  update(query) {
    return request({
      url: `/${this.uri}/update/${query.id}`,
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'post',
      data: query.query,
    })
  }

  get(id) {
    return request({
      url: `/${this.uri}/show/${id}`,
      method: 'get',
    })
  }

  students(institution_id) {
    return request({
      url: '/students/index',
      method: 'post',
      data: institution_id,
    })
  }

  institutionUsers(institution_id, query) {
    return request({
      url: `/institutions/institution-users/${institution_id}`,
      method: 'post',
      data: query,
    })
  }

  institutionExperiments(institution_id, query) {
    return request({
      url: `/institutions/institution-experiments/${institution_id}`,
      method: 'post',
      data: query,
    })
  }

  experimentSessionsChart(institution_id) {
    const url = institution_id
      ? `/institutions/experiment-sessions-chart/${institution_id}`
      : '/institutions/experiment-sessions-chart'
    return request({
      url,
      method: 'get',
    })
  }

  lookups() {
    return request({
      url: `${this.uri}/lookups`,
      method: 'get',
    })
  }

  aiConfigurations(id) {
    return request({
      url: `/ai-configurations/show-by-institution-id/${id}`,
      method: 'get',
    })
  }

  storeAiConfigurations(query) {
    return request({
      url: '/ai-configurations/store',
      method: 'post',
      data: query,
    })
  }

  updateCustomAIConfig(query, id) {
    return request({
      url: `/institutions/updateCustomAI/${id}`,
      method: 'post',
      data: query,
    })
  }

  updateAiConfigurations(query) {
    return request({
      url: `/ai-configurations/update/${query.id}`,
      method: 'post',
      data: query,
    })
  }

  aiConfigurationsTypesLookups() {
    return request({
      url: '/ai-configurations/types',
      method: 'get',
    })
  }

  lmsConfigurations(id) {
    return request({
      url: `/lms-configurations/show-by-institution-id/${id}`,
      method: 'get',
    })
  }

  storeLmsConfigurations(query) {
    return request({
      url: '/lms-configurations/store',
      method: 'post',
      data: query,
    })
  }

  updateLmsConfigurations(query) {
    return request({
      url: `/lms-configurations/update/${query.id}`,
      method: 'post',
      data: query,
    })
  }

  updateLmsEnabled(query, id) {
    return request({
      url: `/institutions/updateLmsEnabled/${id}`,
      method: 'post',
      data: query,
    })
  }

  lmsConfigurationsTypesLookups() {
    return request({
      url: '/lms-configurations/types',
      method: 'get',
    })
  }

  getMicrosoftConfigurations(id) {
    return request({
      url: `/microsoft-configurations/show-by-institution-id/${id}`,
      method: 'get',
    })
  }

  storeMicrosoftConfigurations(query) {
    return request({
      url: '/microsoft-configurations/store',
      method: 'post',
      data: query,
    })
  }

  updateMicrosoftConfigurations(query, id) {
    return request({
      url: `/microsoft-configurations/update/${id}`,
      method: 'post',
      data: query,
    })
  }

  updateMicrosoftEnabled(query, id) {
    return request({
      url: `/institutions/updateMicrosoftEnabled/${id}`,
      method: 'post',
      data: query,
    })
  }

  activate(id) {
    return request({
      url: `/institutions/activate/${id}`,
      method: 'post',
    })
  }

  deactivate(id) {
    return request({
      url: `/institutions/deactivate/${id}`,
      method: 'post',
    })
  }
}

export { Institutions as default }
